module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"row section-margin-lg\"> <div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"> <h3>Log In</h3> <form id=\"login-form\"> <div class=\"form-group\"> <input class=\"form-control\" id=\"session-email\" name=\"session[email]\" placeholder=\"Email Address\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.email ))
    ; __append("\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"session-password\" name=\"session[password]\" placeholder=\"Password\" type=\"password\"> </div> <button class=\"btn btn-lg btn-blue pull-right\" type=\"submit\">Log in </button> </form> <a href=\"/reset\">Forgot your password?</a> <div class=\"clearfix\"></div> </div> </div> </div> <div class=\"section-padding text-center bg-lightest\"> <h4 class=\"\">Need an account?</h4> <a class=\"btn btn-red btn-lg\" href=\"/signup\">Sign up</a> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/login.ejs
// module id = 894
// module chunks = 1